import { Icon, required } from '@jfs/ui-new'
import { useEffect } from 'react'
import { DatePickerReact } from '../../../../components/DatePicker'
import { Dropdown } from '../../../../components/Dropdown'
import { useLazyApiData, useStores } from '../../../../data/store'
import { AadhaarAwareTextInput } from '../comps/AadhaarAwareTextInput'
import { UploadEntityFile } from '../comps/UploadEntityFile'
import { getAdditionalDocCategory } from './dropdownData'
import { styles } from './styles'

export const documentUploadForm = (dropdownData: any, editable: boolean, isStoreMerchant: boolean) => ({
  key: 'DOCUMENT_UPLOAD_FORM',
  verticalFlex: 1,
  contentOverflow: 'auto',
  horizontalFlex: 1,
  contentPadding: 24,
  title: 'Document Upload',
  formItems: [
    {
      fieldName: 'doc_upload',
      ComponentName: UploadEntityFile,
      uploadButtonTitle: 'Upload Selected DOC',
      uploadDialogTitle: 'Upload Required Doc',
      hintMessage: '',
      nonEditableTitle: 'Uploaded Additional Documents',
      jdmsTableColumns: ['Document Category', 'Document Type', 'Document Number', 'Date of Expiry', 'Action'],
      hideColumnsJdms: ['kycDocuments', 'MERCHANT_DOCUMENT_TYPE'],
      editable,
      uploadId: dropdownData?.uploadId,
      acceptMultiple: true,
      optionalFields: [
        {
          key: 'docExpiryDate',
          exceptions: [{ key: 'docType', values: ['FS0002', 'IBS002'] }],
        },
        {
          key: 'documentId',
          exceptions: [{ key: 'docType', values: ['FS0002', 'IBS002', 'Z00005'] }],
        },
      ],
      documentListHeaderMapper: [
        {
          key: 'MERCHANT_DOCUMENT_TYPE',
          header: 'Document Category',
        },
        {
          key: 'NAME',
          header: 'File Name',
        },
        {
          key: 'MERCHANT_DOCUMENT_NAME',
          header: 'Doc Type',
        },
        {
          key: 'expiry',
          header: 'Expiry Date',
        },
        {
          key: 'documentNumber',
          header: 'Doc Id',
        },
        {
          key: '',
          header: '',
        },
      ],
      uploadFileReqMapper: {
        documentName: 'docType',
        documentNumber: 'documentId',
        dateOfExpiry: 'docExpiryDate',
        documentCategory: 'docCategory',
        documentType: 'docType',
      },
      uploadFileReqConstants: {
        uploadType: 'ENTITY',
      },
      categoryFieldName: 'docCategory',
      isOptional: true,
      rowData: [
        {
          fieldName: 'docCategory',
          ComponentName: Dropdown,
          label: 'Doc Category',
          labelType: 'label',
          minHeight: 32,
          validationSchema: required,
          title: 'Select Document Category',
          data: getAdditionalDocCategory(dropdownData?.lovData, 'DocumentCategory'),
          dataFieldToRead: 'description',
          fullWidthContent: true,
        },
        {
          fieldName: 'docType',
          ComponentName: DocTypeDropdown,
          docCategoryFieldName: 'docCategory',
          label: 'Doc Type',
          labelType: 'label',
          minHeight: 32,
          validationSchema: required,
          title: 'Select document type',
          documentCategoryList: getAdditionalDocCategory(dropdownData?.lovData, 'DocumentCategory'),

          fullWidthContent: true,
          testID: 'authSignatoryPoiType',
        },
        {
          fieldName: 'documentId',
          ComponentName: AadhaarAwareTextInput,
          docTypeFieldName: 'docType',
          label: 'Document Id (Optional)',
          required: true,
          placeholder: 'Document Id',
          validationSchema: required,
          ...styles.textinputStyle(editable),
          testID: 'documentId',
        },

        {
          fieldName: 'docExpiryDate',
          ComponentName: DatePickerReact,
          touched: true,
          label: ' Expiry Date  (Optional)',
          placeholder: '',
          showYearDropdown: true,
          scrollableYearDropdown: true,
          minDate: new Date(),
          maxDate: new Date().setDate(new Date().getDate() + 365 * 100),
          rightComponent: <Icon id="CALENDAR" color={'PRIMARY'} />,
          labelPaddingBottom: 8,
          validationSchema: required,
          color: 'BLACK_21',
          labelFontSize: 12,
          paddingVertical: 5,
          shouldCloseOnSelect: true,
          labelFontFamily: 'jiotype-medium',
          testID: 'authSignatoryPoiExpiryDate',
        },
      ],
      docCategoryLov: getAdditionalDocCategory(dropdownData?.lovData, 'DocumentCategory'),
      testID: 'authSignatoryPoi',
    },
  ],
  onSubmit: async (values) => {},
})

export const DocTypeDropdown = (props: any) => {
  const { fetchKycDocCategories } = useStores((store) => ({
    fetchKycDocCategories: store.fetchKycDocCategories,
    //fetchKycDocCategories
  }))

  const [lazyFetchKycDocCategories, fetchKycDocCategoriesHandler] = useLazyApiData(fetchKycDocCategories)

  console.log('DocTypeDropdown', props)
  console.log('DocTypeDropdown', props?.documentCategoryList)
  const selectedDocCatagoryValue = props?.documentCategoryList?.find(
    (item) => item?.description == props?.allValues?.[props.docCategoryFieldName],
  )?.value
  console.log('selectedDocCatagoryValue =', selectedDocCatagoryValue)

  useEffect(() => {
    props?.setFieldValue(props.fieldName, '')
    selectedDocCatagoryValue && lazyFetchKycDocCategories({ documentCategory: selectedDocCatagoryValue }, false)
  }, [selectedDocCatagoryValue])

  return (
    <Dropdown
      {...props}
      selectedData={(selected) => {
        if (selected !== 'NA') {
          const initialArray = props.allValues?.docMetaData ?? []
          const selectedKey = fetchKycDocCategoriesHandler.data?.find((item) => selected === item.value)?.key
          if (selectedKey) {
            props?.setFieldValue('docMetaData', [...initialArray, { value: selected, key: selectedKey }])
          }
        }
      }}
      data={
        selectedDocCatagoryValue
          ? fetchKycDocCategoriesHandler?.state === 'fulfilled' && fetchKycDocCategoriesHandler?.data?.length > 0
            ? fetchKycDocCategoriesHandler?.data
            : [{ value: 'NA' }]
          : []
      }
    />
  )
}
